import { Component, ViewChild, OnInit } from '@angular/core';
import { Equipment, EquipmentService, EquipmentType, Provider, Providers, SitePlant, } from "../../../equipments/services/equipment.service"
import { NotificationService } from "../../../common/component/notification/notification.service"
import { ActivatedRoute, Router } from '@angular/router';
import { confirm } from 'devextreme/ui/dialog';
import { ProspectListItem } from 'src/app/facility/types/ProspectListItem';
import { ContractService } from 'src/app/contracts/services/contract.service';

@Component({
    selector: 'app-modifycontract',
    templateUrl: './modifyequipment.component.html',
    styleUrls: ['./modifyequipment.component.scss']
})
export class ModifyEquipmentComponent implements OnInit {
    id: number = 0;
    siteId: number = 0;
    fromFacilityPage: boolean;
    sites: SitePlant[];
    equipments: Equipment[];
    filteredEquipments: Equipment[];
    equipmentItem: Equipment;
    selectedSite: string;
    showFilterRow: boolean;
    showHeaderFilter: boolean;
    equipmentPopupVisible: boolean;
    isOxygenSupply: boolean;
    productionFacilityId: string;
    equipmentsResponseReceived: boolean;
    equipmentTypesResponseReceived: boolean;
    equipmentProviderResponseReceived: boolean;
    techProviderResponseReceived: boolean;
    enggProviderResponseReceived: boolean;
    gasProviderResponseReceived: boolean;
    businessModelResponseReceived: boolean;
    prospectItemsResponseReceived: boolean;
    equipmentCustomerUnspecified: boolean;
    equipmentCustomerVarious: boolean;
    isLoadPanelVisible: boolean = false;
    awardYears: string[];
    awardYear: string;
    equipmentName: string;
    selectionModeValue = 'single';
    priorities: string[];
    awardStatusList: string[];
    activeEquipmentTypes: Provider[];
    equipmentTypes: Provider[];
    activeEquipmentProvidersDataSource: Provider[];
    equipmentProvidersDataSource: Provider[];
    activeTechProvidersDataSource: Provider[];
    techProvidersDataSource: Provider[];
    activeEngineeringProvidersDataSource: Provider[];
    engineeringProvidersDataSource: Provider[];
    activeIndustrialGasDataSource: Provider[];
    industrialGasDataSource: Provider[];
    businessModels: Provider[];
    equipmentDropDownList: Provider[];
    prospectListItems: ProspectListItem[];
    createMode: boolean;
    popupVisible: boolean;
    showSupplyMode: boolean;
    equipmentDropDownValue: number;
    activeFlag: boolean = true;
    modalPopupType: Providers;
    popupHeaderTitle: string;
    popupDropDownLabel: string;
    popupTextBoxLabel: string;
    supplyModeNotes: string = 'If Business Model is SOG, select the associated supply mode.\r\nOnSite = supplying to single customer.\r\Pipeline = supplying to multiple customers.'


    constructor(private equipmentService: EquipmentService,
        private contractService: ContractService,
        private route: ActivatedRoute,
        private router: Router,
        public notificationService: NotificationService) {
        this.priorities = [
            'Unspecified',
            'Various'
        ];

        this.awardStatusList = [
            '',
            'Final Award',
            'LOI'
        ];
        this.popupVisible = false;
        this.awardYears = contractService.getAwardYears();
    }

    ngOnInit(): void {
        this.isLoadPanelVisible = true;
        //**************Get User ID On Edit********************* */
        this.getEquipmentTypes();
        this.getProviders(Providers.Equipment);
        this.getProviders(Providers.Technology);
        this.getProviders(Providers.Engineering);
        this.getProviders(Providers.IndustrialGas);
        this.getBusinessModels();
        this.getProspectListItems();

        this.route.queryParams
            .subscribe(params => {
                this.siteId = params['siteId'];
                this.fromFacilityPage = params['facilityCallBack'];
            }
            );

        this.route.params.subscribe(params => {
            this.id = params['id'];
            if (params['id'] != null) {
                this.equipmentItem = new Equipment();
                this.getEquipmentInfo(this.id);
                this.createMode = false;
                this.productionFacilityId = params['facilityId'];
            }
            else {
                this.createMode = true;
                this.equipmentItem = new Equipment();
                this.isLoadPanelVisible = false;
                this.equipmentItem.productionFacilityId = this.productionFacilityId = params['facilityId'];
            }
        });
    }

    getProviders(providerType: Providers) {
        this.isLoadPanelVisible = true;
        this.equipmentService.getProviders(providerType).subscribe({
            next: providers => {
                switch (providerType) {
                    case Providers.Equipment:
                        providers = providers.sort((a, b) => { return a.providerName.localeCompare(b.providerName) });
                        this.equipmentProvidersDataSource = providers;
                        providers = providers.filter(p => p.activeFlag);
                        this.activeEquipmentProvidersDataSource = providers;
                        this.equipmentProviderResponseReceived = true;
                        this.addNewItem(this.equipmentProvidersDataSource);
                        break;
                    case Providers.Technology:
                        providers = providers.sort((a, b) => { return a.providerName.localeCompare(b.providerName) });
                        this.techProvidersDataSource = providers;
                        providers = providers.filter(p => p.activeFlag);
                        this.activeTechProvidersDataSource = providers;
                        this.techProviderResponseReceived = true;
                        this.addNewItem(this.techProvidersDataSource);
                        break;
                    case Providers.Engineering:
                        providers = providers.sort((a, b) => { return a.providerName.localeCompare(b.providerName) });
                        this.engineeringProvidersDataSource = providers;
                        providers = providers.filter(p => p.activeFlag);
                        this.activeEngineeringProvidersDataSource = providers;
                        this.enggProviderResponseReceived = true;
                        this.addNewItem(this.engineeringProvidersDataSource);
                        break;
                    case Providers.IndustrialGas:
                        providers = providers.sort((a, b) => { return a.providerName.localeCompare(b.providerName) });
                        this.industrialGasDataSource = providers;
                        providers = providers.filter(p => p.activeFlag);
                        this.activeIndustrialGasDataSource = providers;
                        this.gasProviderResponseReceived = true;
                        this.addNewItem(this.industrialGasDataSource);
                        break;
                    default:
                        break;
                }
                if (this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching provider data", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    getEquipmentTypes() {
        this.isLoadPanelVisible = true;
        this.equipmentService.getEquipmentTypes().subscribe({
            next: equipmentTypes => {
                equipmentTypes = equipmentTypes.sort((a, b) => { return a.providerName.localeCompare(b.providerName) });
                this.equipmentTypes = equipmentTypes;
                equipmentTypes = equipmentTypes.filter(e => e.activeFlag);
                this.activeEquipmentTypes = equipmentTypes;
                this.equipmentTypesResponseReceived = true;
                this.addNewItem(this.equipmentTypes);
                if (this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching Equipment types", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    getBusinessModels() {
        this.isLoadPanelVisible = true;
        this.equipmentService.getBusinessModels().subscribe({
            next: businessModels => {
                this.businessModels = businessModels.filter(e => e.activeFlag);
                this.businessModelResponseReceived = true;
                if (this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching business models", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    getProspectListItems() {
        this.isLoadPanelVisible = true;
        this.equipmentService.getProspectListItems().subscribe({
            next: prospectListItems => {
                this.prospectListItems = prospectListItems.filter(e => e.listType == 'SupplyMode');
                this.prospectItemsResponseReceived = true;
                if (this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching prospect list items", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    getEquipmentInfo(id: number) {
        this.isLoadPanelVisible = true;
        this.equipmentService.getEquipmentInfo(this.id).subscribe({
            next: equipmentData => {
                this.equipmentItem = equipmentData;
                this.productionFacilityId = this.equipmentItem.productionFacilityId;
                this.equipmentItem.supplyModeNotes = this.supplyModeNotes;
                this.awardYear = this.equipmentItem.awardYear;
                this.equipmentCustomerVarious = this.equipmentItem.equipmentCustomerVarious;
                this.equipmentCustomerUnspecified = this.equipmentItem.equipmentCustomerUnspecified;
                if (this.equipmentCustomerVarious) this.equipmentItem.customerSiteDesc = 'Various';
                if (this.equipmentCustomerUnspecified) this.equipmentItem.customerSiteDesc = 'Unspecified';
                this.equipmentsResponseReceived = true;
                if (this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching Equipment Info", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    handleSubmit(e) {
        this.isLoadPanelVisible = true;
        // e.preventDefault();
        this.equipmentItem.equipmentCustomerUnspecified = this.equipmentCustomerUnspecified;
        this.equipmentItem.equipmentCustomerVarious = this.equipmentCustomerVarious;
        this.equipmentItem.activeFlag = true;

        this.equipmentService.saveEquipmentDetails(this.equipmentItem).subscribe(data => {
            if (data) {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("success", "Record saved successfully", null);
                this.redirectToPage();
            }
        },
            error => {
                this.notificationService.alert("error", "Error occured while fetching the contract information", error);
                this.isLoadPanelVisible = false;
            });
    }

    onCancelClick(e) {
        let that = this;
        var result = confirm("Your changes will be lost. Are you sure?", "Confirm");
        result.then(function (dialogResult) {
            if (dialogResult) {
                that.redirectToPage();
            }
        });
    }

    openPopup() {
        this.popupVisible = true;
    }

    setPopupVisibility(data) {
        this.popupVisible = data;
    }

    setSiteId(data) {
        this.equipmentItem.customerSiteId = data;
    }

    setCustomer(data) {
        this.equipmentItem.customerSiteDesc = data;
        this.equipmentCustomerUnspecified = false;
        this.equipmentCustomerVarious = false;
    }

    categoryChanged = (event: any) => {
        //console.log(event.previousValue);
        if (event.value == 'SOG')
            this.showSupplyMode = true;
        else
            this.showSupplyMode = false;
    }

    handleVariousSwitchChange(e) {
        if (e.value) {
            this.equipmentCustomerUnspecified = false;
            this.equipmentItem.customerSiteDesc = 'Various';
        }
        else {
            if (!this.equipmentCustomerUnspecified) this.equipmentItem.customerSiteDesc = null;
        }
    }

    handleUnspecifiedSwitchChange(e) {
        if (e.value) {
            this.equipmentCustomerVarious = false;
            this.equipmentItem.customerSiteDesc = 'Unspecified';
        }
        else {
            if (!this.equipmentCustomerVarious) this.equipmentItem.customerSiteDesc = null;
        }
    }

    hasAllResponseReceived(): boolean {
        var resp = this.equipmentTypesResponseReceived && this.equipmentProviderResponseReceived
            && this.techProviderResponseReceived && this.enggProviderResponseReceived && this.gasProviderResponseReceived
            && this.businessModelResponseReceived && this.prospectItemsResponseReceived;
        if (this.createMode)
            return resp;
        else
            return resp && this.equipmentsResponseReceived;
    }

    openEquipmentProvider() {
        this.popupHeaderTitle = 'Equipment Provider';
        this.popupDropDownLabel = 'Manufacturer Proprietary Equipments';
        this.equipmentPopupVisible = true;
        this.modalPopupType = Providers.Equipment;
        this.equipmentDropDownList = this.equipmentProvidersDataSource;
    }

    openTechProvider() {
        this.popupHeaderTitle = 'Technology Provider'
        this.popupDropDownLabel = 'Technology Providers';
        this.equipmentPopupVisible = true;
        this.modalPopupType = Providers.Technology;
        this.equipmentDropDownList = this.techProvidersDataSource;
    }

    openEngineeringProvider() {
        this.popupHeaderTitle = 'Engineering Provider';
        this.popupDropDownLabel = 'Engineering Providers';
        this.equipmentPopupVisible = true;
        this.modalPopupType = Providers.Engineering;
        this.equipmentDropDownList = this.engineeringProvidersDataSource;
    }

    openIndustrialGasProvider() {
        this.popupHeaderTitle = 'Industrial Gas Provider';
        this.popupDropDownLabel = 'Industrial Gas Providers';
        this.equipmentPopupVisible = true;
        this.modalPopupType = Providers.IndustrialGas;
        this.equipmentDropDownList = this.industrialGasDataSource;
    }

    openEquipmentType() {
        this.popupHeaderTitle = 'Equipment Type';
        this.popupDropDownLabel = 'Equipment Types';
        this.equipmentPopupVisible = true;
        this.modalPopupType = Providers.EquipmentType;
        this.equipmentDropDownList = this.equipmentTypes;
    }

    onCancelPopupClick(e) {
        let that = this;
        var result = confirm("Your changes will be lost. Are you sure?", "Confirm");
        result.then(function (dialogResult) {
            if (dialogResult) {
                that.closePopup();
            }
        });
    }

    closePopup() {
        this.equipmentDropDownList = [];
        this.equipmentPopupVisible = false;
        this.equipmentDropDownValue = null;
        this.activeFlag = null;
    }

    addNewItem(items: Provider[]): Provider[] {
        var providers: Provider[] = items;
        var newItem = new Provider();
        newItem.providerName = '*************Add New*************';
        providers.unshift(newItem);
        return providers;
    }

    onContentReady(e) {
        e.component.registerKeyHandler("escape", arg => {
            arg.stopPropagation();
        });
    }

    onEquipmentDropDownValueChanged(e) {
        if (e.value) {
            this.equipmentName = e.component.option("text");
        }
        else {
            this.equipmentName = '';
        }
        var dropDownItem = this.equipmentDropDownList.filter(n => n.id && n.id == e.value);
        if (dropDownItem && dropDownItem.length > 0) this.activeFlag = dropDownItem[0].activeFlag;
        else this.activeFlag = true;
    }

    redirectToPage() {
        if (this.fromFacilityPage) {
            this.router.navigate([`/facility/${this.siteId}/${this.productionFacilityId}`]);
        }
        else {
            this.router.navigate(['/equipments']);
        }
    }

    savePopupInfo() {
        var request = new Provider();
        request.providerName = this.equipmentName;
        request.id = this.equipmentDropDownValue;
        request.activeFlag = this.activeFlag;
        this.equipmentService.saveProviderInfo(request, this.modalPopupType).subscribe(data => {
            let providerInfoList: Provider[];
            if (data) {
                this.notificationService.alert("success", "Record saved successfully", null);
                switch (this.modalPopupType) {
                    case Providers.Equipment:
                        providerInfoList = this.equipmentProvidersDataSource;
                        break;
                    case Providers.Technology:
                        providerInfoList = this.techProvidersDataSource;
                        break;
                    case Providers.Engineering:
                        providerInfoList = this.engineeringProvidersDataSource;
                        break;
                    case Providers.IndustrialGas:
                        providerInfoList = this.industrialGasDataSource;
                        break;
                    case Providers.EquipmentType:
                        providerInfoList = this.equipmentTypes;
                        break;
                    default:
                        break;
                }

                if (request.id) {
                    var item = providerInfoList.filter(e => e.id == request.id);
                    if (item && item.length > 0) {
                        item[0].providerName = request.providerName;
                        item[0].activeFlag = request.activeFlag;
                    }
                }
                else {
                    var newItem = new Provider();
                    newItem.id = data;
                    newItem.providerName = request.providerName;
                    newItem.activeFlag = request.activeFlag;
                    providerInfoList.push(newItem);
                }

                providerInfoList.sort((a, b) => { return a.providerName.localeCompare(b.providerName) });
                if (this.modalPopupType == Providers.Equipment) this.activeEquipmentProvidersDataSource = providerInfoList.filter(p => p.activeFlag);
                if (this.modalPopupType == Providers.Technology) this.activeTechProvidersDataSource = providerInfoList.filter(p => p.activeFlag);
                if (this.modalPopupType == Providers.Engineering) this.activeEngineeringProvidersDataSource = providerInfoList.filter(p => p.activeFlag);
                if (this.modalPopupType == Providers.IndustrialGas) this.activeIndustrialGasDataSource = providerInfoList.filter(p => p.activeFlag);
                this.closePopup();
            }
        },
            error => {
                this.notificationService.alert("error", "Error occured while saving the information", error);
                this.isLoadPanelVisible = false;
            });
    }
}